module.exports = __webpack_public_path__ + "static/img/icon_rotation_animation@3x.657a266d.png";